/**
 * Used for coloring -> this.colors.first
 * Used in:
 *  [header] -> ["LOGO", "Notification", "myPage", "myProfile"]
 * 
 */

export default {
  data(){
    return{
      // idist
      // colors: {
      //   first: '222222',
      //   second: '222222',
      //   third: '464646',
      //   fouth: '767676',
      //   fifth: '999999'
      // }

      // leanist 
      colors: {
        first: '3FA2F7',
        second: '222222',
        third: '464646',
        fouth: '767676',
        fifth: '999999'
      }
    };
  }
}